import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { BounceLoader } from "react-spinners";

export default function HomeProducts() {
  const [ProductList, setProductList] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    GetProductsList();
  }, []);

  const GetProductsList = () => {
    setLoading(true);
    PostService(API_URL?.GET_PRUDUCTS_LIST, {}).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setProductList(res?.data?.data);
      }
      setLoading(false);
    });
  };

  return (
    <div className="tp-blog__area p-relative  pt-50 pb-40">
      <div className="container">
        <div className="row text">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <h4 className="text-left">Our Products </h4>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 text-right">
            <Link className="large head banner" to={"/our-products"}>
              {" "}
              View ALL
            </Link>
          </div>
        </div>
        <div className="row">
          {ProductList &&
            ProductList.map((data,ind) => (
              <>
                {(data?.product_title === "Canvas Print" ||
                  data?.product_title === "Plexi Prints" ||
                  data?.product_title === "Art Tray") && (
                  <div
                    className="col-xl-4 col-lg-4 col-md-6   wow tpfadeUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".3s"
                    style={{
                      visibility: "visible",
                      animationDuration: "0.9s",
                      animationDelay: "0.3s",
                      animationName: "tpfadeUp",
                    }}
                    key={ind}
                  >
                    <div className="tp-blog__item">
                      <div className="tp-blog__thumb">
                        <Link to={`/our-products/${data?.id}`}>
                          <img
                            className="w-100"
                            src={data?.product_image}
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="tp-blog__content">
                        <h5 className="tp-blog__title">
                          <Link to={`/our-products/${data?.id}`}>
                            {data?.product_title}
                          </Link>
                        </h5>
                        <div className="tp-blog__meta">
                          {/* <span>{data?.description}</span> */}
                          <span>{data?.description.split(" ")
                                                  .length > 18
                                                  ? data?.description
                                                      .split(" ")
                                                      .slice(0, 18)
                                                      .join(" ") +
                                                    (data?.description.split(
                                                      " "
                                                    ).length > 18
                                                      ? "..."
                                                      : "")
                                                  : data?.description}</span>
                        </div>
                        <div className="tp-blog__meta">
                          <span style={{ fontWeight: 600 }}>
                            Prints starts at ${data?.price}
                          </span>
                        </div>
                        <div className="tp-blog__link">
                          <Link to={`/our-products/${data?.id}`}>
                            Shop Canvas
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
      
      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#003bff"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
